import { useEffect, useState } from 'react';
import { useTour } from '../tour/TourContext';

const KEY = 'cs-tour-prompted';

// Shown once, the first time a user opens the app. "Yes!" launches the tour.
export default function FirstVisitPrompt() {
  const { requestTour } = useTour();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, '1');
    setShow(false);
  };

  return (
    <div className="modal-backdrop" onClick={dismiss}>
      <div className="modal" style={{ width: 380 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-body" style={{ textAlign: 'center', padding: 28 }}>
          <h2 style={{ margin: '0 0 10px', fontSize: 30, fontWeight: 800, letterSpacing: '-0.02em' }}>
            Take a tour?
          </h2>
          <p className="muted" style={{ marginTop: 0, fontSize: 15 }}>
            It's a few clicks to show you around.
          </p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                dismiss();
                requestTour();
              }}
            >
              Yes!
            </button>
            <button className="btn" onClick={dismiss}>
              No Thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
